var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/modules/_user-agent.js